import React from "react";
import ManagementNavbar from "./ManagementNavbar";
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Grow,
    IconButton,
    Snackbar,
    TextField,
    Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Backend from "../../backend/Backend"
import {DeleteForever} from "@mui/icons-material";
import ExecutiveData from "../../backend/dataservices/ExecutiveData";


function createSuggestionsData(_name, _executive) {
    return {name: _name, executive: _executive};
}

function ManagementExecutivesPage() {

    const [suggestions, setSuggestions] = React.useState([]);
    const [openSuggestion, setOpenSuggestion] = React.useState(false);
    const [suggestionValue, setSuggestionValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [createNewExecutive, setCreateNewExecutive] = React.useState(false);
    const [fullname, setFullname] = React.useState('');
    const [firstname, setFirstname] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [contraction, setContraction] = React.useState('');
    const [notes, setNotes] = React.useState('');
    const [originalData, setOriginalData] = React.useState(new Map());
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarText, setSnackbarText] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
    const [deletable, setDeletable] = React.useState(false);
    const [showDeleteButton, setShowDeleteButton] = React.useState(false);
    const [showExecutiveDeleteDialog, setShowExecutiveDeleteDialog] = React.useState(false);


    // React.useEffect(() => {
    //     (async () => {
    //
    //     })();
    // }, [])

    function searchExecutive(name) {
        setLoading(true);
        ExecutiveData.searchExecutiveByName(name).then(generateRows);
    }


    async function loadDataFromDatabase(rawExecutiveData) {
        let tempRows = [];
        for (const executive of rawExecutiveData) {
            tempRows.push(createSuggestionsData(executive.D_Name, executive));
        }
        return tempRows;
    }

    function generateRows(rawExecutiveData) {
        loadDataFromDatabase(rawExecutiveData).then(data => {
            setSuggestions(data);
            setLoading(false);
        });
    }

    function checkForDeletable(executive) {
        setShowDeleteButton(true);
        ExecutiveData.getEmployees(executive).then(employees => {
            if (employees.length === 0) {
                setDeletable(true);
            } else {
                setDeletable(false);
            }
        });
    }

    function handleInputValue(newInputValue) {
        if (newInputValue != null) {
            setCreateNewExecutive(false);

            let executive = newInputValue.executive;
            let fName = '';
            let lName = '';
            if(executive.D_Name.split(',').length > 1) {
                let s = executive.D_Name.split(',')[1];
                fName = s === null ? '' : s.slice(0, 0) + s.slice(1);
            }
            lName = executive.D_Name.split(',')[0] === null ? '' : executive.D_Name.split(',')[0];
            setFirstname(fName);
            setLastname(lName);
            setFullname(newInputValue.name);
            setNotes(executive.D_Bemerkungen == null ? '' : executive.D_Bemerkungen);
            setContraction(executive.D_Diszi);

            let map = new Map();
            map.set('firstname', fName);
            map.set('lastname', lName);
            map.set('fullname', newInputValue.name);
            map.set('contraction', executive.D_Diszi);
            map.set('notes', executive.D_Bemerkungen == null ? '' : executive.D_Bemerkungen);
            setOriginalData(map);
            checkForDeletable(executive);
        } else {
            setShowDeleteButton(false);
        }
    }

    function handleCreateNewExecutiveClick() {
        setCreateNewExecutive(true);
        clearAllData();
    }

    function clearAllData() {
        setFirstname('');
        setLastname('');
        setFullname('');
        setNotes('');
        setContraction('');
    }

    function handleFirstnameChange(event) {
        let value = event.target.value;
        setFirstname(value)
        handleFullname(lastname, value);
    }

    function handleLastnameChange(event) {
        let value = event.target.value;
        setLastname(value)
        handleFullname(value, firstname);
    }

    function handleContractionChange(event) {
        let value = event.target.value;
        setContraction(value);
    }

    function handleFullname(l, f) {
        if (f !== '' || l !== '') {
            setFullname(l + ', ' + f);
        } else {
            setFullname('');
        }
    }

    function discardChanges() {
        if (createNewExecutive) {
            clearAllData();
        } else {
            setFirstname(originalData.get('firstname'));
            setLastname(originalData.get('lastname'));
            setFullname(originalData.get('fullname'));
            setNotes(originalData.get('notes'));
        }
    }

    function saveExecutive() {
        ExecutiveData.getExecutiveByContraction(contraction).then(value => {
            if(value.length > 0 && originalData.get('contraction') !== contraction) {
                setSnackbarSeverity('error');
                setSnackbarText(value[0].D_Name + " besitzt bereits das Kürzel " + contraction);
                setSnackbarOpen(true);
                return false;
            }
            return true;
        }).then(valid => {
            if (createNewExecutive) {
                let executive = {
                    D_Name: lastname + ", " + firstname,
                    D_Bemerkungen: notes === '' ? null : notes,
                    D_Diszi: contraction
                }
                if (valid) {
                    Backend.postData('/api/actions/neuerdiszi', executive).then(value => {
                        setSnackbarSeverity('success');
                        setSnackbarText('Führungskraft erfolgreich angelegt!');
                        setSnackbarOpen(true);
                    }, (error) => {
                        setSnackbarSeverity('error');
                        setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                        setSnackbarOpen(true);
                    });
                }
            } else {
                if (valid) {
                    let executive = suggestionValue.executive;
                    let uri = executive._links.self.href
                    executive.D_Name = lastname + ", " + firstname;
                    executive.D_Diszi = contraction;
                    executive.D_Bemerkungen = notes;

                    delete executive._links;

                    Backend.putData(uri, executive).then(value => {
                        setSnackbarText('Änderungen erfolgreich gespeichert');
                        setSnackbarSeverity("success")
                        setSnackbarOpen(true);
                    }, (error) => {
                        if (error.code === "ER_ROW_IS_REFERENCED_2") {
                            setSnackbarText('Diese Führungskraft hat noch referenzierte Verwaltungen!');
                            setSnackbarSeverity("error")
                            setSnackbarOpen(true);
                        } else {
                            setSnackbarSeverity('error');
                            setSnackbarText('Ein unerwarteter Fehler ist aufgetreten');
                            setSnackbarOpen(true);
                        }
                    });
                }
            }
        });
    }

    function closeSnackbar() {
        setSnackbarOpen(false);
    }

    function deleteExecutive() {
        setShowExecutiveDeleteDialog(false);
            ExecutiveData.deleteExecutive(contraction).then(value => {
                setSuggestionValue(null);
                setShowDeleteButton(false);
                setDeletable(false);
                setSnackbarText('Führungskraft gelöscht');
                setSnackbarSeverity("success")
                setSnackbarOpen(true);
            }, (error) => {
                setSnackbarText('Führungskraft konnte nicht gelöscht werden');
                setSnackbarSeverity("error")
                setSnackbarOpen(true);
            })

    }

    function handleExecutiveDialogClose() {
        setShowExecutiveDeleteDialog(false);
    }

    return (
        <div>
            <ManagementNavbar initValue={"/management/executives"}/>
            <Box width={'100%'} sx={{
                borderBottom: '1px solid lightgrey',
                paddingTop: '10px',
                paddingBottom: '20px',
                marginBottom: '10px'
            }}>
                <Grid container spacing={4} style={{alignItems: 'center', justifyContent: 'center'}}>
                    <Grid item xs={1}/>
                    <Grid item xs={8}>
                        <Autocomplete options={suggestions}
                                      fullWidth
                                      open={openSuggestion}
                                      onOpen={() => {
                                          setOpenSuggestion(true)
                                      }}
                                      onClose={() => {
                                          setOpenSuggestion(false)
                                      }}
                                      inputValue={inputValue || ''}
                                      onInputChange={(event, newInputValue) => {
                                          setInputValue(newInputValue == null ? '' : newInputValue);
                                          if (newInputValue.length >= 2) {
                                              searchExecutive(newInputValue);
                                          }
                                      }}

                                      value={suggestionValue}
                                      onChange={(event, newInputValue) => {
                                          setSuggestionValue(newInputValue);
                                          handleInputValue(newInputValue);
                                      }}
                                      isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                                      getOptionLabel={(option) => option.name}
                                      renderOption={(props, option) => {
                                          return (
                                              <li {...props} key={option.executive['D_Diszi']}>
                                                  {option.name}
                                              </li>
                                          );
                                      }}
                                      renderInput={(params => (
                                          <TextField
                                              {...params}
                                              variant={"outlined"}
                                              label={"Suche..."}
                                              sx={{width: '100%',}}
                                              InputProps={{
                                                  ...params.InputProps,
                                                  endAdornment: (
                                                      <React.Fragment>
                                                          {loading ? <CircularProgress color={"primary"}/> : null}
                                                          {params.InputProps.endAdornment}
                                                      </React.Fragment>
                                                  ),
                                              }}
                                          />
                                      ))}/>
                    </Grid>
                    <Grid item xs={2}>
                        <Button style={{width: '100%'}} variant={"contained"} endIcon={<AddIcon/>}
                                onClick={handleCreateNewExecutiveClick}>
                            Führungskraft anlegen
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                        {showDeleteButton ?
                            <Box marginLeft={10}>
                                <Tooltip
                                    title={deletable ? 'Führungskraft löschen' : 'Führungskraft kann nicht gelöscht werden, da dieser noch Mitarbeiter zugewiesen sind'}>
                                    <span>
                                    <IconButton color={'error'} disabled={!deletable} size={'large'} onClick={() => {
                                        setShowExecutiveDeleteDialog(true);
                                    }}>
                                        <DeleteForever fontSize={'large'}/>
                                    </IconButton>
                                        </span>
                                </Tooltip>
                            </Box>
                            :
                            null
                        }
                    </Grid>
                </Grid>
            </Box>

            <Dialog open={showExecutiveDeleteDialog} onClose={handleExecutiveDialogClose}>
                <DialogTitle>
                    Mitarbeiter löschen
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Möchten Sie die Führungskraft {fullname} wirklich unwiderruflich löschen?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleExecutiveDialogClose} variant={"text"}
                            style={{color: "gray"}}>Abbrechen</Button>
                    <Button color={"error"} variant={"text"} onClick={deleteExecutive}>Löschen</Button>
                </DialogActions>
            </Dialog>



            {suggestionValue != null || createNewExecutive ?
                <Card elevation={3} style={{width: '80%', margin: '5% 10% 0 10%'}}>
                    <CardHeader style={{borderBottom: '1px solid lightgrey'}} title={fullname}/>
                    <CardContent>
                        <Grid container spacing={{xs: 2, md: 5}} width={'100%'}>
                            <Grid item xs={5}>
                                <TextField variant={'standard'} label={'Vorname'} required fullWidth value={firstname}
                                           onChange={handleFirstnameChange}/>
                            </Grid>
                            <Grid item xs={5}>
                                <TextField variant={'standard'} label={'Nachname'} required fullWidth value={lastname}
                                           onChange={handleLastnameChange}/>
                            </Grid>
                            <Grid item xs={2}>
                            {createNewExecutive ?
                                <TextField variant={'standard'} label={'Kürzel'} required fullWidth value={contraction}
                                           onChange={handleContractionChange}/>
                             :
                                <TextField variant={'standard'} label={'Kürzel'} required fullWidth value={contraction}
                                                 disabled={true}/>
                            }
                            </Grid>


                            <Grid item xs={12}>
                                <TextField variant={'standard'} label={'Bemerkungen'} fullWidth value={notes}
                                           onChange={(event) => setNotes(event.target.value)}/>
                            </Grid>

                            <Grid item xs={4}>
                                <Button disabled={
                                    originalData.get('firstname') === firstname
                                    && originalData.get('lastname') === lastname
                                    && originalData.get('fullname') === fullname
                                    && originalData.get('contraction') === contraction
                                    && originalData.get('notes') === notes}
                                        fullWidth style={{color: "gray"}}
                                        onClick={discardChanges}>Änderungen verwerfen</Button>
                            </Grid>
                            <Grid item xs={4}/>
                            <Grid item xs={4}>
                                <Button disabled={(originalData.get('firstname') === firstname
                                        && originalData.get('lastname') === lastname
                                        && originalData.get('fullname') === fullname
                                        && originalData.get('notes') === notes
                                        && originalData.get('contraction') === contraction)
                                    || firstname === '' || lastname === '' || contraction === ''}
                                        fullWidth color={"primary"} onClick={saveExecutive}>Speichern</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                :
                null
            }
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={closeSnackbar}
                      anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                <Alert onClose={closeSnackbar} severity={snackbarSeverity} sx={{width: '100%'}}>
                    {snackbarText}
                </Alert>
            </Snackbar>
        </div>

    )

}

export default ManagementExecutivesPage;